import { createFieldControl } from './createFieldControl.ts';

export const inputVariants = createFieldControl('flex items-center');

export const getNumberFieldSize = (size?: string): 'small' | 'medium' | 'large' => {
  const result = size === 'sm' ? 'small' : size === 'lg' || size === 'xl' ? 'large' : 'medium';
  return result;
};
